module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-segment-js/gatsby-browser.js'),
      options: {"plugins":[],"prodKey":"bOg3ALHlNbjPLvUWiin0rtUYCxZtS6e8","devKey":"bOg3ALHlNbjPLvUWiin0rtUYCxZtS6e8","trackPage":false,"delayLoad":false,"delayLoadTime":1000},
    },{
      plugin: require('../node_modules/gatsby-plugin-facebook-pixel/gatsby-browser.js'),
      options: {"plugins":[],"pixelId":"821364325390010"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
